/* tslint:disable */

declare var Object: any;
export interface PostServiceInterface {
  "id"?: number;
}

export class PostService implements PostServiceInterface {
  "id": number;
  constructor(data?: PostServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PostService`.
   */
  public static getModelName() {
    return "PostService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PostService for dynamic purposes.
  **/
  public static factory(data: PostServiceInterface): PostService{
    return new PostService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PostService',
      plural: 'PostServices',
      path: 'PostServices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/PostService.ts